export default {
	title: 'हित (स्टेक्स)',
	url: 'stakes',
	no_description: 'कोई लक्ष्य परिभाषित नहीं',
	context_worse: 'नकारात्मक',
	context_best: 'सकारात्मक',
	tabs: {
		filters: {
			title: 'दृश्य फ़िल्टर'
		},
		general: {
			title: 'सामान्य'
		},
		export: {
			title: 'निर्यात'
		},
		comments: {
			title: 'इतिहास'
		},
		bot: {
			title: 'बुद्धिमत्ता'
		}
	},
	messages: {
		edit_stake: 'हित संपादन',
		create_stake: 'नया हित बनाएँ'
	},
	onboarding: {
		title: 'हितों की समीक्षा',
		description:
			'AI ने आपके विषय के संरचनात्मक हितों की पहचान की है। जाँचें कि यदि कुछ नहीं किया गया तो आप क्या खो सकते हैं या प्राप्त कर सकते हैं, यह वास्तव में दर्शाते हैं। आवश्यकतानुसार समायोजित करें, हटाएँ या पूर्ण करें।'
	}
};
